import { RedirectCommand, Router, Routes, type UrlTree } from '@angular/router'
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component'
import { PrivateLayoutComponent } from './layouts/private-layout/private-layout.component'
import { AuthenticationService } from './core/services/auth.service'
import { inject } from '@angular/core'
import { AuthGuard } from './helpers/auth.guard'

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/sign-in',
    pathMatch: 'full',
  },
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [
      (route, state) => {
        const currentUser = inject(AuthenticationService).session
        const router: Router = inject(Router)
        return true;
        // if (currentUser) {
        //   return true;
        // } else {
        //   router.navigate(['/auth/sign-in'], {
        //     queryParams: { returnUrl: state.url }
        //   });
        //   return false;
        // }
      },
    ],
    loadChildren: () =>
      import('./views/views.route').then((mod) => mod.VIEW_ROUTES),
  },
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./views/other-pages/other-page.route').then(
        (mod) => mod.OTHER_PAGES_ROUTES
      ),
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./views/auth/auth.route').then((mod) => mod.AUTH_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'error-404-2'
  },
]
